import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['globalSelect']

  connect () {
    this.setupChoicesReadyListener()
  }

  setupChoicesReadyListener () {
    // Слушаем событие готовности Choices.js на всех селектах категории
    this.element.addEventListener('choices:ready', (event) => {
      const select = event.target

      // Проверяем что это селект категории
      if (select.dataset.categorySyncTarget !== 'categorySelect') return

      // Если есть выбранная глобальная категория - устанавливаем её
      if (this.hasGlobalSelectTarget && this.globalSelectTarget.value) {
        const stringValue = String(this.globalSelectTarget.value)
        event.detail.choices.setChoiceByValue(stringValue)
      }
    })
  }

  updateAllCategories () {
    const selectedValue = this.globalSelectTarget.value
    if (!selectedValue) return

    const stringValue = String(selectedValue)
    const categorySelects = this.element.querySelectorAll('[data-category-sync-target="categorySelect"]')

    categorySelects.forEach(select => {
      if (select.choicesInstance) {
        select.choicesInstance.setChoiceByValue(stringValue)
      }
    })
  }
}
